import { render, staticRenderFns } from "./JoinClass.vue?vue&type=template&id=14c58d56&scoped=true"
import script from "./JoinClass.vue?vue&type=script&lang=js"
export * from "./JoinClass.vue?vue&type=script&lang=js"
import style0 from "./JoinClass.vue?vue&type=style&index=0&id=14c58d56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c58d56",
  null
  
)

export default component.exports